<template>
  <div v-if="type === 'bar'" style="width: 100%; height: 100%;">
    <div class="bar row text-center">
      <idx-skeleton style="width: 15%;" height="50" class="m-2" />
      <idx-skeleton style="width: 15%;" height="260" class="m-2" />
      <idx-skeleton style="width: 15%;" height="200" class="m-2" />
      <idx-skeleton style="width: 15%;" height="150" class="m-2" />
    </div>
  </div>

  <div v-else-if="type === 'pizza'" class="pizza">
    <div class="row text-center">
      <idx-skeleton
        width="250"
        height="250"
        radius="250"
        class="m-2"
        inner="true"
      />
    </div>
  </div>

  <div v-else-if="type === 'area'" style="width: 100%; height: 100%;">
    <div class="area row text-center p-4">
      <idx-skeleton height="300" class="clip m-4" />
    </div>
  </div>

  <div v-else-if="type === 'line'" style="width: 100%; height: 100%;">
    <div class="line row text-center">
      <idx-skeleton width="" height="50" class="m-2" />
    </div>
  </div>

  <div v-else-if="type === 'keywords'" style="width: 100%; height: 100%;">
    <div class="keywords row text-center">
      <idx-skeleton width="" height="50" class="m-2" />
    </div>
  </div>

  <div v-else-if="type === 'map'" style="width: 100%; height: 100%;">
    <div class="map row text-center">
      <div class="idx-map-skeleton"></div>
    </div>
  </div>

  <div v-else-if="type === 'words'" style="width: 100%; height: 100%;">
    <div class="row text-center" style="align-items: center; justify-content: center; max-width: 450px; margin-left: auto; margin-right: auto;">
       <div class="" style="align-items: center; justify-content: center;">
        <idx-skeleton width="190" height="26" class="m-1" radius="16" />
      <idx-skeleton width="140" height="10" class="m-1" radius="16" />
       </div>
        <idx-skeleton width="210" height="14" class="m-1" radius="16" />
        <idx-skeleton width="130" height="25" class="m-1" radius="16" />
        <idx-skeleton width="40" height="10" class="m-1" radius="16" />
        <idx-skeleton width="130" height="25" class="m-1" radius="16" />
        <idx-skeleton width="170" height="11" class="m-1" radius="16" />
        <idx-skeleton width="100" height="18" class="m-1" radius="16" />
        <idx-skeleton width="170" height="11" class="m-1" radius="16" />
        <idx-skeleton width="190" height="33" class="m-1" radius="16" />
        <idx-skeleton width="210" height="14" class="m-1" radius="16" />
        <idx-skeleton width="130" height="25" class="m-1" radius="16" />
        <idx-skeleton width="100" height="18" class="m-1" radius="16" />
        <idx-skeleton width="100" height="18" class="m-1" radius="16" />
    </div>
  </div>
</template>

<script>
import idxSkeleton from '@/components/molecules/idx-skeleton';
import backgroundImage5 from '../../../assets/street-background.jpg';

export default {
  props: {
    type: { type: String },
    width: { type: String },
    height: { type: String },
    radius: { type: String },
  },
  components: {
    idxSkeleton,
  },
  data() {
    return {
      imgs: [],
    };
  },
  mounted() {
    this.imgs = [backgroundImage5];
  },
};
</script>

<style lang="scss" scoped>
.bar {
  align-items: baseline;
  justify-content: center;
}

.area {
  .clip {
    width: 80%;
    clip-path: polygon(
      62% 34%,
      91% 64%,
      100% 55%,
      100% 100%,
      0 100%,
      0% 60%,
      28% 77%
    );
  }
}

.pizza {
  width: 100%;
  height: 100%;
  text-align: center;
  align-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  .inner {
    position: absolute;
    justify-content: center;
    width: 140px;
    height: 140px;
    border-radius: 200px;
    background: #ffffff;
    z-index: 99;
    margin-top: auto;
    margin-bottom: auto;
    top: 188px;
  }
}
.idx-map-skeleton {
  width: 100%;
  height: 580px;
  margin-left: 15%;
  margin-right: 15%;
  margin-top: 25px;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(8%, rgba(130, 130, 130, 0.2)),
    color-stop(18%, rgba(130, 130, 130, 0.3)),
    color-stop(33%, rgba(130, 130, 130, 0.2))
  );
  background: linear-gradient(
    to right,
    rgba(130, 130, 130, 0.2) 8%,
    rgba(130, 130, 130, 0.3) 18%,
    rgba(130, 130, 130, 0.2) 33%
  );
  mask-image: url('../../../assets/fake-chart-map.png');
  mask-repeat: no-repeat;
  mask-size: 100%;
  -webkit-mask-image: url('../../../assets/fake-chart-map.png');
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: 100%;
  animation: wave-lines 1.25s infinite ease-out;
}

.idx-words-skeleton {
  width: 100%;
  height: 300px;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(8%, rgba(130, 130, 130, 0.2)),
    color-stop(18%, rgba(130, 130, 130, 0.3)),
    color-stop(33%, rgba(130, 130, 130, 0.2))
  );
  background: linear-gradient(
    to right,
    rgba(130, 130, 130, 0.2) 8%,
    rgba(130, 130, 130, 0.3) 18%,
    rgba(130, 130, 130, 0.2) 33%
  );
  mask-image: url('../../../assets/keywords-chart.png');
  mask-repeat: no-repeat;
  mask-size: 100%;
  -webkit-mask-image: url('../../../assets/keywords-chart.png');
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: 100%;
  animation: wave-lines 1.25s infinite ease-out;
}

.idx-map-skeleton-x {
  width: 80%;
  height: 360px;
  background: linear-gradient(
    to right,
    rgba(130, 130, 130, 0.2) 8%,
    rgba(130, 130, 130, 0.3) 18%,
    rgba(130, 130, 130, 0.2) 33%
  );
  mask-image: url('../../../assets/fake-chart-map.png');
  mask-repeat: no-repeat;
  mask-size: 80%;
  -webkit-mask-image: url('../../../assets/fake-chart-map.png');
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: 80%;
  background-repeat: no-repeat;
  animation: wave-lines 1.75s infinite linear;
  //-webkit-animation: 3s ease 0s normal forwards 1 fadein;
  // animation: 3s ease 0s normal forwards 1 fadein;
  // animation-iteration-count: infinite;
}
@keyframes wave-lines {
  0% {
    background-position: -920px 0;
  }
  100% {
    background-position: 920px 0;
  }
}
@keyframes wave-squares {
  0% {
    background-position: -668px 0;
  }
  100% {
    background-position: 668px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/idx-skeleton-chart/index.vue